import httpClient from '@/api/http-client';

type ServerTime = {
  unixTimestampMs: number,
}

async function getElapsedSecondsSince (startDate: string) {
  const startTimestampMs = new Date(startDate).getTime();
  const serverTimestampMs = await getUnixTimestampMs();
  const durationMs = serverTimestampMs - startTimestampMs;
  return Math.round(durationMs / 1e3);
}

async function getUnixTimestampMs () {
  const { 
    data: {
      unixTimestampMs,
    },
  } = await httpClient.get<ServerTime>('time');

  return unixTimestampMs;
}

export default {
  getElapsedSecondsSince,
  getUnixTimestampMs,
};
